import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getFlashbook } from '../../services/flashbooks';

function useGetFlashbook({ enabled = true }: { enabled?: boolean } = {}) {
  const { user } = useUser();

  return useQuery({
    queryKey: ['flashbook', { employeeId: user?.userId }],
    enabled: !!user?.userId && enabled,
    queryFn: () => getFlashbook(user!.userId),
  });
}

export default useGetFlashbook;
